export default function H1({ text }: header) {
  return <h1 className="text-2xl font-semibold text-gray-900">{text}</h1>;
}

interface header {
  text: string;
}
